import React, { useEffect } from 'react';
// import Head from 'next/head';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Iframe from 'react-iframe';
import Fade from 'react-reveal/Fade';

import address from '../assets/images/contact/address.gif';
import phone from '../assets/images/contact/phone.gif';
import email from '../assets/images/contact/email.gif';

const useStyles = makeStyles(theme => ({
    background: {
        height: "50em",
        [theme.breakpoints.down("md")]: {
            backgroundImage: `url("/assets/mobileBackground.jpg")`
        }
    },
    leftBar: {
        backgroundColor: "#fcfcfc",
        border: `1px solid #e5e5e5`,
        padding: "20px 5px",

        minHeight: "120px",
        marginBottom: "15px"
    },
    map: {
        height: "100%",
        overflow: "hidden",
        position: "relative",
    },
}))

export default function Contact(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

    const content = props.content.contact;
    const language = props.language;

    const setValue = props.setValue;
    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(false);
    }, [setValue]);

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
            </Head> */}

            <Grid container direction="row" dir={language === "per" ? "rtl" : null} style={{ overflowX: "hidden", }}>
                <Grid item container direction="column" justify="center" alignItems="center" style={{ marginBottom: matchesMD ? "5em" : 0, marginTop: matchesSM ? "1em" : matchesMD ? "5em" : 0 }} md={4} xl={3}>
                    <Grid item style={{ width: matchesSM ? "90%" : null }}>
                        <Grid container direction="column">
                            <Grid item style={{ marginBottom: "50px" }}>
                                <Typography variant="h2" align={matchesMD ? "center" : undefined} style={{ lineHeight: 1 }}>{content.header}</Typography>
                                <Typography variant="body1" align={matchesMD ? "center" : undefined} style={{ color: theme.palette.common.blue }}>
                                    {content.subHeader}
                                </Typography>
                            </Grid>

                            <Grid item >
                                <Grid container direction="column" alignItems="center">
                                    <Grid item style={{ width: "100%" }}>
                                        <Grid item container direction="column" alignItems="center">

                                            <Grid item style={{ width: "100%" }}>
                                                <Fade duration={1000} distance={matchesSM ? "0" : null} right >
                                                    <Grid item container className={classes.leftBar}>
                                                        <Grid item container justify="center">
                                                            <img alt="address" src={address} style={{ width: 125, maxWidth: "100%" }} />
                                                        </Grid>
                                                        <Grid item container justify="center">
                                                            <Typography variant="h3" align="center" style={{ lineHeight: "30px", fontSize: "1.1rem", maxWidth: "250px" }}>
                                                                {content.address}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Fade>
                                            </Grid>

                                            <Grid item style={{ width: "100%" }}>
                                                <Fade duration={1500} distance={matchesSM ? "0" : null} right >
                                                    <Grid item container className={classes.leftBar}>
                                                        <Grid item container justify="center">
                                                            <img alt="phone" src={phone} style={{ width: 90, maxWidth: "100%" }} />
                                                        </Grid>
                                                        <Grid item container justify="center">
                                                            <Typography dir="ltr" variant="h3" align="center" style={{ lineHeight: "30px", fontSize: "1.1rem", fontFamily: language === "PER" ? 'vazirFarsiDigit, Helvetica, sans-serif' : null }}>
                                                                {content.phone1}<br />
                                                                {content.phone2}<br />
                                                                {content.phone3}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Fade>
                                            </Grid>


                                            <Grid item style={{ width: "100%" }}>
                                                <Fade duration={2000} distance={matchesSM ? "0" : null} right >
                                                    <Grid item container className={classes.leftBar}>
                                                        <Grid item container justify="center">
                                                            <img alt="email" src={email} style={{ width: 160, maxWidth: "100%" }} />
                                                        </Grid>
                                                        <Grid item container justify="center" >
                                                            <Typography variant="h3" align="center" style={{ fontSize: "1.1rem", wordWrap: "break-word", width: "100%" }}>
                                                                {content.email}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Fade>
                                            </Grid>

                                        </Grid >
                                    </Grid >
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>

                <Grid item container direction={matchesMD ? "column" : undefined} className={classes.background} justify={matchesMD ? "center" : undefined} md={8} xl={9} alignItems="center">
                    <Grid item style={{ width: "100%", height: "100%" }}>
                        <Grid item container className={classes.map}>
                            <Iframe src="https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d809.9535733853033!2d51.42248961299097!3d35.706187271868835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d35.7063823!2d51.4224201!5e0!3m2!1sen!2sde!4v1609704299923!5m2!1sen!2sde" width="100%" frameborder="0" allowfullscreen="" aria-hidden="false" tabindex="0" />
                        </Grid >
                    </Grid >
                </Grid>
            </Grid >

        </React.Fragment>
    )
}

